import ScrollLock from "@bornfight/b-scroll-lock";

export default class Popup {
    constructor() {
        /**
         *
         * @type {HTMLBodyElement}
         */
        this.nav = document.querySelector(".js-navigation-wrapper");

        /**
         *
         * @type {ScrollLock} contains methods for scroll lock and unlock (.lockScroll() / .unlockScroll())
         */
        this.scrollLock = new ScrollLock();

        /**
         *
         * @type {NodeListOf<Element>}
         */
        this.popupOpenBtns = document.querySelectorAll(".js-open-popup");

        /**
         *
         * @type {NodeListOf<Element>}
         */
        this.popups = document.querySelectorAll(".js-popup");

        if (this.popupOpenBtns.length > 0) {
            this.popupOpenBtns.forEach((popupOpenBtn) => {
                this.init(popupOpenBtn);
            });

            document.addEventListener("keyup", (ev) => {
                if (ev.keyCode === 27 || ev.key === "Escape") {
                    this.popups.forEach((popup) => {
                        this.closePopup(popup);
                    });
                }
            });
        }
    }

    /**
     *
     * @type {Element || HTMLElement} popupOpenBtn
     */
    init(popupOpenBtn) {
        const targetPopup = document.querySelector(popupOpenBtn.getAttribute("href"));

        if (targetPopup == null) {
            return;
        }

        const closePopupBtns = targetPopup.querySelectorAll(".js-close-popup");

        popupOpenBtn.addEventListener("click", (ev) => {
            ev.preventDefault();

            if (!targetPopup.classList.contains("is-opened")) {
                this.openPopup(targetPopup);
            }
        });

        if (closePopupBtns == null) {
            return;
        }

        closePopupBtns.forEach((closePopupBtn) => {
            closePopupBtn.addEventListener("click", (ev) => {
                ev.preventDefault();

                if (targetPopup.classList.contains("is-opened")) {
                    this.closePopup(targetPopup);
                }
            });
        });
    }

    /**
     *
     * @type {Element || HTMLElement} targetPopup
     */
    openPopup(targetPopup) {
        targetPopup.classList.add("is-opened");
        this.nav.classList.add("is-popup-opened");
        this.scrollLock.lockScroll();

        if (targetPopup.querySelector('[data-plyr="play"]') && !targetPopup.querySelector(".plyr--playing")) {
            setTimeout(() => {
                targetPopup.querySelector('[data-plyr="play"]').click();
            }, 300);
        }
    }

    /**
     *
     * @type {Element || HTMLElement} targetPopup
     */
    closePopup(targetPopup) {
        targetPopup.classList.remove("is-opened");
        this.nav.classList.remove("is-popup-opened");
        this.scrollLock.unlockScroll();

        if (targetPopup.querySelector('[data-plyr="play"]') && targetPopup.querySelector(".plyr--playing")) {
            targetPopup.querySelector('[data-plyr="play"]').click();
        }
    }
}
